import { useState } from 'react';
import { PAYMENT_STATUS, RegisteredEvent } from '@type/db-types';
import { CircularProgress, FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { updateRegistrantPaymentStatus } from '@modules/supabase/payments';
import { Tag } from 'antd';

interface Props {
    refresh: () => void;
    registrant: RegisteredEvent;
}

export default function PaymentStatusSelector({ refresh, registrant }: Props) {
    const { paymentId, paymentStatus } = registrant;
    const [loading, setLoading] = useState(false);

    const handleChange = async ({ target: { value: role } }: SelectChangeEvent) => {
        if (!paymentId) return;

        setLoading(true);
        await updateRegistrantPaymentStatus(role as PAYMENT_STATUS, paymentId);

        // invalidate local user data & refetch
        refresh();
        setLoading(false);
    };

    if (loading) return <CircularProgress />;

    if (!registrant) return null;

    return (
        <FormControl fullWidth>
            <Select
                id="permission-level-select"
                value={paymentStatus || ''}
                onChange={handleChange}
                // padding right to ensure the dropdown arrow does not overlap the text
                SelectDisplayProps={{ style: { padding: '0.5rem', paddingRight: '1.75rem' } }}
            >
                <MenuItem value={PAYMENT_STATUS.CANCELLED}>
                    <Tag color="error">Cancelled</Tag>
                </MenuItem>
                <MenuItem value={PAYMENT_STATUS.PENDING}>
                    <Tag color="processing">Pending</Tag>
                </MenuItem>
                <MenuItem value={PAYMENT_STATUS.PAID}>
                    <Tag color="success">Paid</Tag>
                </MenuItem>
                <MenuItem value={PAYMENT_STATUS.PROCESSING}>
                    <Tag color="processing">Processing</Tag>
                </MenuItem>
                <MenuItem value={PAYMENT_STATUS.ERRORED}>
                    <Tag color="error">Failed</Tag>
                </MenuItem>
                <MenuItem value={PAYMENT_STATUS.UNPAID}>
                    <Tag color="error">Unpaid</Tag>
                </MenuItem>
            </Select>
        </FormControl>
    );
}
